// Root selectors for caching
let _selectors = {
    sections: '.timeline-section',
    sectionNav: '.js-timeline-nav',
    desktopSectionNav: '.js-timeline-nav-desktop',
    mobileSectionNav: '.js-timeline-nav-mobile',
    sectionNavMenu: '.js-timeline-nav-items',
    sectionNavLink: '.js-timeline-nav a[href^="#"]',
    sectionWrap: '.timeline-section_wrap',
    sectionWrapTitle: '.timeline-section_title',
};

let timelineTitleGap = 80;

// Module options
let _options = {};

// Cached Elements
let _el = {};

// Module Variables
let _vars = {};

// Section Elements and Variables
let _sectionIDs = [];

// Module init
const _setupTimeline = (options) => {
    _options = Object.assign({}, _options, options);
    _setElements();
    _setSections();
    _bindEvents();
};

const _init = (options) => {

    // Mobile only
    if (window.innerWidth < 768) {
        _setupTimeline(options);
        return;
    }

    // Desktop: init immediately if nav element exists
    const navElement = document.querySelector('.js-timeline-nav');
    if (navElement) {
        _setupTimeline(options);
        return;
    } else {
        // Create an observer instance to watch for when the nav is injected
        const navObserver = new MutationObserver((mutations, obs) => {
            const navElement = document.querySelector('.js-timeline-nav');
            if (navElement) {
                obs.disconnect(); // Stop observing once we find the element
                _setupTimeline(options);
            }
        });

        navObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};


const _bindEvents = () => {

    // Timeline link click
    if (_vars.sectionNavLink) {
        _el.sectionNavLink.forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                _scrollToSection(e);
            });
        });
    }

    // Desktop: Setup Intersection Observer for timeline sections
    if (_vars.sections && _vars.desktopSectionNav) {
        const observerOptions = {
            root: null,
            rootMargin: `0px 0px -50% 0px`,
            threshold: 0
        };

        const scrollObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const id = entry.target.getAttribute('id');
                    const currentLink = _el.desktopSectionNav[0].querySelector('a[href=\\#' + id + ']');

                    if (currentLink && currentLink.classList.contains('is-active')) {
                        return;
                    }
                    
                    // Remove active class from all links
                    _el.desktopSectionNav[0].querySelectorAll('a.is-active').forEach(link => {
                        link.classList.remove('is-active');
                    });
                    
                    // Add active class to current link
                    currentLink.classList.add('is-active');
                }
            });
        }, observerOptions);

        // Observe all timeline sections
        _el.sections.forEach(section => {
            scrollObserver.observe(section);
        });
    }

    window.addEventListener('scroll', function() {
        if(_el.sectionWrap) {
            _checkSectionTop()
        }
    })
};

// This is needed to add the gradient behind timeline year headings
const _checkSectionTop = () => {
    $(_el.sectionWrap).each(function(){
        if($(window).scrollTop() + timelineTitleGap >= $(this).offset().top) {
            $(this).find(_el.sectionWrapTitle).addClass('reached-top');
        } else {
            $(this).find(_el.sectionWrapTitle).removeClass('reached-top');
        }
    });
}

// Cache sections for scroll to section navbar
const _setSections = () => {
    if(_vars.sections && _vars.sectionNav) {
        _el.sections.forEach($el => {
            const id = $el.getAttribute('id');

            if(id) {
                _sectionIDs.push(id)
            }
        });
    }
};

const _scrollToSection = (e) => {

    let anchor = e.target.closest("a");
    if(!anchor) {return;}

    const href = anchor.getAttribute("href");

    if(document.querySelector(href)) {
        const element = document.querySelector(href);
        const top = element.getBoundingClientRect().top + window.scrollY - timelineTitleGap;

        window.scrollTo({
            top: top,
            behavior: "smooth"
        });
        
        // Add active class to the clicked timeline item
        document.querySelectorAll('.timeline-item').forEach(item => {
            item.classList.remove('is-active');
        });
        
        // Set active class on the clicked item
        anchor.classList.add('is-active');
    }
}

// Set/Reset and cache module elements
const _setElements = () => {
    // Cache elements into _el
    Object.keys(_selectors).forEach(key => {
        const el = document.querySelectorAll(_selectors[key]);
        _el[key] = el;
        _vars[key] = el.length;
    });
};

// Public functions defined here
const Timeline = {
    init: _init
};

export default Timeline;
